import { useToast } from '@/components/ui/use-toast';
import { LabelGroup } from '@/features/label/types';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { label } from '@/utils/label';
import { useMutation } from 'react-query';

export type setAssignedAdminDto = {
  eventId: number;
  userId: number | null;
};

export const setAssignedAdmin = ({ eventId, userId }: setAssignedAdminDto) => {
  return axios.put(`/event/${eventId}/set-assigned-admin`, { userId });
};

type UseSetAssignedAdminOptions = {
  config?: MutationConfig<typeof setAssignedAdmin>;
};

export const useSetAssignedAdmin = ({ config }: UseSetAssignedAdminOptions) => {
  const { toast } = useToast();

  return useMutation({
    onError: (_: any, __: any, ___: any) => {
      toast({
        variant: 'destructive',
        title: label('something_went_wrong', LabelGroup.GLOBAL)
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("events");
      queryClient.refetchQueries("events");
      toast({
        variant: 'success',
        title: label('event_assigned_admin_set', LabelGroup.ORGANIZER_EVENT_LIST)
      });
    },
    ...config,
    mutationFn: ({ eventId, userId }: any) => setAssignedAdmin({ eventId, userId })
  });
};
